var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoin = function SvgCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 15,
    fill: "none",
    viewBox: "0 0 8 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.453 2.083V0H4.64v2.083zM.093 3.542H8v1.25H.093zM.093 6.875H8v1.25H.093zM.093 10.208H8v1.25H.093zM3.453 15v-2.083H4.64V15z",
    clipRule: "evenodd"
  })));
};
export default SvgCoin;